import { render } from "./text-barsr3.vue?vue&type=template&id=9b5ffa4a&scoped=true"
const script = {}

import "./text-barsr3.vue?vue&type=style&index=0&id=9b5ffa4a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b5ffa4a"],['__file',"src/views/other/cssfx/components/text-barsr3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b5ffa4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b5ffa4a', __exports__)) {
    console.log('reload')
    api.reload('9b5ffa4a', __exports__)
  }
  
  module.hot.accept("./text-barsr3.vue?vue&type=template&id=9b5ffa4a&scoped=true", () => {
    console.log('re-render')
    api.rerender('9b5ffa4a', render)
  })

}


export default __exports__